export default "<div class=\"noRecordsFound\">\n\t<img src=\"./assets/media/misc/no_records_found.png\">\n</div>\n"